import { render, staticRenderFns } from "./LocationCatalogues.vue?vue&type=template&id=20d43e28&scoped=true&"
import script from "./LocationCatalogues.vue?vue&type=script&lang=ts&"
export * from "./LocationCatalogues.vue?vue&type=script&lang=ts&"
import style0 from "./LocationCatalogues.vue?vue&type=style&index=0&id=20d43e28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d43e28",
  null
  
)

export default component.exports